import PropTypes from 'prop-types';
// material-ui
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project-imports
import MainCard from 'components/MainCard';

// ==============================|| STATISTICS - REPORT CARD ||============================== //

export default function ReportCard({ primary, secondary, day, iconPrimary }) {
  return (
    <MainCard
      sx={{
        minHeight: 120, // ✅ ensures all cards same height
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Grid
        container
        alignItems="center"
        wrap="nowrap"
      >
        {/* Left Icon */}
        <Grid item sx={{ mr: 2 }}>   {/* ✅ adds gap between icon and text */}
          <img
            src={iconPrimary}
            alt="icon"
            className="widget-icon"
            style={{ display: 'block' }}
          />
        </Grid>

        {/* Right Text */}
        <Grid item xs>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center', // ✅ keeps text vertically centered
              height: '100%',
            }}
          >
            <Stack spacing={0.25} alignItems="flex-start">
              <Typography variant="h3" className="analytic-no">
                {primary}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {secondary}
              </Typography>
              <Typography
                variant="h6"
                color="text.secondary"
                className="analytic-day"
              >
                {day}
              </Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </MainCard>
  );
}

ReportCard.propTypes = {
  primary: PropTypes.any,
  secondary: PropTypes.any,
  day: PropTypes.any,
  iconPrimary: PropTypes.any,
};
